enum ActionTaken {
  EDITED = 'EDITED',
  REPORTED = 'REPORTED',
}

export default ActionTaken;
